import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm$baseForm$c02Audit;
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", {
    ref: "container",
    staticClass: "custom-theme"
  }, [_c("div", {
    staticClass: "app-page-header",
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_c("div", {
    staticClass: "left"
  }, [_vm._v(" " + _vm._s(_vm.uid ? "\u7F16\u8F91\u51FD\u8BC1\u3010".concat(_vm.baseForm.c02ConfirmCode, "-").concat(_vm.baseForm.c02Status, "\u3011") : "新增函证") + " "), _c("el-popover", {
    attrs: {
      placement: "top-start",
      width: "400",
      trigger: "hover"
    }
  }, [_c("div", {
    staticClass: "print-content",
    attrs: {
      id: "print-content"
    }
  }, [_c("img", {
    attrs: {
      src: _vm.ewm
    }
  })]), _c("cpsc-icon", {
    attrs: {
      slot: "reference",
      hover: true,
      "is-iconfont": true,
      name: "erweima1688"
    },
    on: {
      click: _vm.toPrint
    },
    slot: "reference"
  })], 1)], 1), _c("div", {
    staticClass: "right"
  }, [_vm.stepActive !== -1 && (_vm.isGroup && _vm.stepActive === 0 || _vm.stepTwoPermissions || _vm.stepThreePermissions || _vm.stepFivePermissions) && !_vm.history ? _c("el-button", {
    staticClass: "app-inline-btn",
    attrs: {
      type: _vm.uid ? "primary" : "success",
      disabled: _vm.baseForm.c02Status === "待审核" || _vm.isReplyPersonnelDisabled,
      size: "mini",
      loading: _vm.loading
    },
    on: {
      click: function click($event) {
        return _vm.submit(true);
      }
    }
  }, [_vm._v(_vm._s(_vm.uid ? "编辑保存" : "新增保存") + " ")]) : _vm._e(), _c("el-button", {
    staticClass: "app-inline-btn",
    attrs: {
      type: "text",
      size: "mini",
      loading: _vm.loading
    },
    on: {
      click: _vm.back
    }
  }, [_vm._v("返回")]), _vm.uid && !_vm.history ? _c("el-dropdown", {
    staticClass: "app-inline-btn",
    attrs: {
      size: "small"
    },
    on: {
      command: _vm.batchHandle
    }
  }, [_c("el-button", {
    staticClass: "app-inline-btn",
    attrs: {
      type: "info",
      size: "mini"
    }
  }, [_vm._v(" 操作"), _c("i", {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _c("el-dropdown-menu", {
    attrs: {
      slot: "dropdown"
    },
    slot: "dropdown"
  }, _vm._l(_vm.batchHandleList, function (item) {
    return _c("el-dropdown-item", {
      key: item.key,
      attrs: {
        command: item.key,
        disabled: item.disabled
      }
    }, [_vm._v(_vm._s(item.text) + " ")]);
  }), 1)], 1) : _vm._e()], 1)]), _c("div", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.baseLoading || _vm.uploading,
      expression: "baseLoading || uploading"
    }],
    staticClass: "content"
  }, [_c("el-steps", {
    staticClass: "steps",
    attrs: {
      active: _vm.stepActive
    }
  }, [_c("el-step", {
    attrs: {
      title: "函证基础信息",
      icon: "el-icon-edit"
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    on: {
      click: function click($event) {
        return _vm.scrollTo(0);
      }
    },
    slot: "title"
  }, [_vm._v("函证基础信息")])]), _c("el-step", {
    attrs: {
      title: "函证审核",
      icon: "el-icon-upload"
    },
    on: {
      click: function click($event) {
        return _vm.scrollTo(1);
      }
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    on: {
      click: function click($event) {
        return _vm.scrollTo(1);
      }
    },
    slot: "title"
  }, [_vm._v("函证审核")])]), _c("el-step", {
    attrs: {
      title: "函证发出",
      icon: "el-icon-picture"
    },
    on: {
      click: function click($event) {
        return _vm.scrollTo(2);
      }
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    on: {
      click: function click($event) {
        return _vm.scrollTo(2);
      }
    },
    slot: "title"
  }, [_vm._v("函证发出")])]), _c("el-step", {
    attrs: {
      title: "函证回函",
      icon: "el-icon-picture"
    },
    on: {
      click: function click($event) {
        return _vm.scrollTo(3);
      }
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    on: {
      click: function click($event) {
        return _vm.scrollTo(3);
      }
    },
    slot: "title"
  }, [_vm._v("函证回函")])]), _c("el-step", {
    attrs: {
      title: "函证跟踪",
      icon: "el-icon-picture"
    },
    on: {
      click: function click($event) {
        return _vm.scrollTo(4);
      }
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    on: {
      click: function click($event) {
        return _vm.scrollTo(4);
      }
    },
    slot: "title"
  }, [_vm._v("函证跟踪")])]), _c("el-step", {
    attrs: {
      title: "函证领取",
      icon: "el-icon-picture"
    },
    on: {
      click: function click($event) {
        return _vm.scrollTo(5);
      }
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    on: {
      click: function click($event) {
        return _vm.scrollTo(5);
      }
    },
    slot: "title"
  }, [_vm._v("函证领取")])])], 1), _c("el-form", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    ref: "form",
    staticClass: "app-custom-form-style form-wrap remove-form-disabled-style",
    attrs: {
      rules: _vm.rules,
      model: _vm.baseForm,
      size: "mini",
      "label-position": "top"
    }
  }, [_c("div", {
    ref: "step-0",
    staticClass: "box"
  }, [_c("div", {
    staticClass: "box-type"
  }, [_vm._v(" 被函证对象"), !!_vm.uid && _vm.isGroup ? _c("span", [_vm._v("(只读)")]) : _vm._e()]), _c("div", {
    staticClass: "box-content remove-form-disabled-style"
  }, [_c("el-row", {
    staticClass: "row",
    attrs: {
      align: "top",
      gutter: 30,
      type: "flex"
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "被函证对象全称(个人对象格式:姓名[手机号])",
      prop: "c02C03Id"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("被函证对象全称(个人对象格式:姓名[手机号])")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      width: 100,
      content: "请指定正确的函证对象全称，针对非个人函证对象，如调用外部第三方无法返回注册地址，大概率为名称错误；个人函证对象请按姓名[手机号]格式输入，以应对在函证对象表中存在重名人员的函证统计。",
      placement: "top"
    },
    slot: "label"
  }, [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)], 1), _c("div", {
    staticClass: "form-item-content-wrap"
  }, [_c("el-select", {
    staticClass: "left",
    attrs: {
      filterable: "",
      remote: "",
      disabled: !!_vm.uid,
      "reserve-keyword": "",
      placeholder: "请输入被函证对象全称",
      "remote-method": _vm.getReceiversList,
      loading: _vm.searchLoading
    },
    on: {
      change: _vm.cusNameHandleSelect
    },
    model: {
      value: _vm.baseForm.c02C03Id,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02C03Id", $$v);
      },
      expression: "baseForm.c02C03Id"
    }
  }, _vm._l(_vm.dataSearchList, function (item) {
    return _c("el-option", {
      key: item.c03Id,
      attrs: {
        label: item.c03CusName,
        value: item.c03Id
      }
    });
  }), 1), !_vm.uid ? _c("el-button", {
    staticClass: "right",
    attrs: {
      type: "primary",
      size: "mini"
    },
    on: {
      click: _vm.createObj
    }
  }, [_vm._v("新增")]) : _vm._e()], 1)])], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-row", {
    attrs: {
      align: "top",
      gutter: 30,
      type: "flex"
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "函证对象类型"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("函证对象类型(银行/企业/个人)")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "所有金融机构发函对象(需发银行函证)请指定为【银行】，所有个人函证对象请指定为【个人】，其他请指定为【企业】。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("el-input", {
    attrs: {
      value: _vm.objForm.c03CusType,
      readonly: true
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "核验人/日期",
      prop: "c03CheckStaff"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("工商信息核验人/日期")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "记录创建函证对象并执行工商信息核验的人员及日期，或由插件推送新的函证对象时自动记录工商信息核验人员及日期。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("el-input", {
    attrs: {
      value: "".concat(_vm.$getStaffName(_vm.objForm.c03CheckStaff), "/").concat(_vm.$options.filters.date(_vm.objForm.c03CheckDate, "yyyy-MM-dd")),
      readonly: true
    }
  })], 1)], 1)], 1)], 1)], 1), _c("el-row", {
    staticClass: "row",
    attrs: {
      align: "top",
      gutter: 30,
      type: "flex"
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "注册地址(三方)",
      prop: "c03CorrectAddress"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("注册地址(三方)")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "由人工核查并录入或对接第三方获取的被函证对象的工商注册地址，该字段可能为空(没有或者无法获取工商注册地址)，可能为核验人员用发函地址替代。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("el-input", {
    staticClass: "app-form-component-select",
    attrs: {
      placeholder: "请输入注册地址(三方)",
      disabled: true,
      maxlength: 200,
      "show-word-limit": ""
    },
    model: {
      value: _vm.objForm.c03CorrectAddress,
      callback: function callback($$v) {
        _vm.$set(_vm.objForm, "c03CorrectAddress", $$v);
      },
      expression: "objForm.c03CorrectAddress"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-row", {
    attrs: {
      align: "top",
      gutter: 30,
      type: "flex"
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "地址核对方式"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("工商信息核对方式(个人或第三方公司)")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "通过人工方式(包含插件对接信用中国获取)指定工商注册地址，或者调用系统的第三方接口(需开通并自充值)自动获取工商注册地址。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("el-input", {
    attrs: {
      value: _vm.objForm.c03CheckType,
      readonly: true
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "核验过程",
      prop: "CusName"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("工商信息核验过程说明")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "人工核验需输入注册地址的核验过程说明，第三方接口调用将记录接口返回数据。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("div", {
    staticClass: "form-item-content-wrap"
  }, [_c("preview-html", {
    staticClass: "left",
    attrs: {
      placement: "left-start",
      content: _vm.objForm.c03CheckProcess
    }
  })], 1)])], 1)], 1)], 1)], 1)], 1)]), _c("div", {
    ref: "step-1",
    staticClass: "box"
  }, [_c("div", {
    staticClass: "box-type"
  }, [_vm._v(" 函证基础信息"), _vm.stepActive !== 0 && _vm.isGroup ? _c("span", [_vm._v("(只读)")]) : _vm._e()]), _c("div", {
    staticClass: "box-content remove-form-disabled-style"
  }, [_c("el-row", {
    staticClass: "row",
    attrs: {
      align: "top",
      gutter: 30,
      type: "flex"
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "\u88AB\u5BA1\u5355\u4F4D",
      prop: "c02AuditCompany"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("被审单位全称")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "正确输入被审计单位的全称，通过被审计单位区分合并作业下不同子公司的函证归属。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("el-input", {
    staticClass: "app-form-component-select",
    attrs: {
      placeholder: "被审单位全称",
      readonly: _vm.uid,
      maxlength: 100,
      "show-word-limit": ""
    },
    model: {
      value: _vm.baseForm.c02AuditCompany,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02AuditCompany", $$v);
      },
      expression: "baseForm.c02AuditCompany"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "函证创建人",
      prop: ""
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("函证创建人")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "记录函证创建时的操作人姓名，插件交互时在获取函证编号时点生成。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("el-input", {
    staticClass: "app-form-component-select",
    attrs: {
      disabled: "",
      placeholder: "请输入函证创建人"
    },
    model: {
      value: _vm.baseForm.c02CreateName,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02CreateName", $$v);
      },
      expression: "baseForm.c02CreateName"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "函证创建日期",
      prop: ""
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("函证创建日期")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "函证创建日期：记录函证创建时的操作日期时点，插件交互时在获取函证编号时点生成。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("el-date-picker", {
    staticClass: "app-form-component-select",
    attrs: {
      type: "date",
      disabled: "",
      "value-format": "yyyy-MM-dd",
      placeholder: "请选择函证创建日期"
    },
    model: {
      value: _vm.baseForm.c02CreateDate,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02CreateDate", $$v);
      },
      expression: "baseForm.c02CreateDate"
    }
  })], 1)], 1)], 1), _c("el-row", {
    staticClass: "row",
    attrs: {
      align: "top",
      gutter: 30,
      type: "flex"
    }
  }, [_c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "函证类型",
      prop: "c02Type"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("函证类型")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "按照发函类型要求指定不同的函证类型，如需增加新的函证类型，需联系函证中心管理员维护新的函证模板及函证类型。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("cpsc-select", {
    staticClass: "select",
    attrs: {
      disabled: _vm.uid,
      filterable: "",
      placeholder: "请选择"
    },
    model: {
      value: _vm.baseForm.c02Type,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02Type", $$v);
      },
      expression: "baseForm.c02Type"
    }
  }, _vm._l(_vm.types, function (item) {
    return _c("el-option", {
      key: item,
      attrs: {
        label: item,
        value: item
      }
    });
  }), 1)], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "函证期数类型(单期/多期)",
      prop: "c02PeriorType"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("函证期数类型(单期/多期)")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "需正确指定非银行类函证的单期/多期类型，如函证所属作业存在跨期，可指定单期(每期数据生成一份询证函)或多期(多期数据生成一份询证函)。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("cpsc-select", {
    staticClass: "select",
    attrs: {
      disabled: _vm.uid,
      placeholder: "请选择函证期数类型"
    },
    model: {
      value: _vm.baseForm.c02PeriorType,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02PeriorType", $$v);
      },
      expression: "baseForm.c02PeriorType"
    }
  }, [_c("el-option", {
    attrs: {
      label: "单期",
      value: "单期"
    }
  }), _c("el-option", {
    attrs: {
      label: "多期",
      value: "多期"
    }
  })], 1)], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "截止日期",
      prop: "c02Perior"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("函证截止日期(函证期数最后日期)")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "一般为每期的最后一天，如为多期函证，截止日期需指定为多期报告期的最后一天。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("el-date-picker", {
    staticClass: "app-form-component-select",
    attrs: {
      type: "date",
      disabled: _vm.uid,
      "value-format": "yyyy-MM-dd",
      placeholder: "请选择函证截止日期"
    },
    model: {
      value: _vm.baseForm.c02Perior,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02Perior", $$v);
      },
      expression: "baseForm.c02Perior"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "样本类型",
      prop: "c02SampleType"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("函证样本类型")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "一般为每期的最后一天，如为多期函证，截止日期需指定为多期报告期的最后一天。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("cpsc-select", {
    staticClass: "select",
    attrs: {
      disabled: !(_vm.stepActive === 0 && _vm.isGroup),
      filterable: "",
      placeholder: "请选择函证样本类型"
    },
    model: {
      value: _vm.baseForm.c02SampleType,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02SampleType", $$v);
      },
      expression: "baseForm.c02SampleType"
    }
  }, _vm._l(_vm.sampleTypes, function (item) {
    return _c("el-option", {
      key: item.n04Id,
      attrs: {
        label: item.n04Value,
        value: item.n04Value
      }
    });
  }), 1)], 1)], 1)], 1), _c("el-row", {
    staticClass: "row",
    attrs: {
      align: "top",
      gutter: 30,
      type: "flex"
    }
  }, [_c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "调用函证模板",
      prop: "c02TmpId"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("调用系统函证模板")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "正确选定函证模板，并维护模板中的发函数据生成html页面类型的预览函证(置已审后可打印)，或者由插件端推送函证数据并调用正确的模板生成预览函证。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("div", {
    staticClass: "tmp-flex-wrap"
  }, [_c("div", {
    staticClass: "left"
  }, [_c("cpsc-select", {
    staticClass: "select",
    attrs: {
      clearable: "",
      filterable: "",
      disabled: !(_vm.stepActive === 0 && _vm.isGroup),
      placeholder: "请选择调用系统函证模板"
    },
    on: {
      change: function change() {
        return _vm.getTemplateDetail();
      }
    },
    model: {
      value: _vm.baseForm.c02TmpId,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02TmpId", $$v);
      },
      expression: "baseForm.c02TmpId"
    }
  }, _vm._l(_vm.templateList, function (item) {
    return _c("el-option", {
      key: item.ctId,
      attrs: {
        label: item.ctName,
        value: item.ctId
      }
    });
  }), 1)], 1), _c("div", {
    staticClass: "right"
  }, [_vm.showTmpTips ? _c("el-tooltip", {
    staticClass: "item",
    attrs: {
      width: 200,
      effect: "dark",
      value: true,
      content: "请注意,函证类型与所选函证模板名称不匹配,请确认是否需要调整,无需调整可忽略本提示",
      placement: "top"
    }
  }, [_c("i", {
    staticClass: "icon el-icon-warning"
  })]) : _vm._e()], 1)])])], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "模板生成函证",
      prop: "c02Confirm"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("模板生成函证预览")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "由系统函证模板结合发函数据生成预览版函证（置已审后可打印），在草稿阶段可手工维护函证数据(一般数据由插件推送，无需在页面中维护)。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _vm.baseForm.c02TmpId ? _c("div", {
    staticClass: "form-item-content-wrap"
  }, [_vm.baseForm.c02Confirm ? _c("popover-pre-doc", {
    staticClass: "left",
    attrs: {
      "task-id": _vm.id,
      "confirm-id": _vm.uid,
      "sys-params": _vm.getSysParams,
      history: _vm.history,
      content: _vm.baseForm.c02Confirm
    }
  }) : _vm._e(), _c("div", {
    staticClass: "right text-right"
  }, [_c("el-button", {
    attrs: {
      size: "mini",
      disabled: !(_vm.stepActive === 0 && _vm.isGroup) || !_vm.baseForm.c02Confirm,
      title: !_vm.baseForm.c02ReturnAddress || !_vm.baseForm.c02ReturnStaff || !_vm.baseForm.c02ReturnFax ? "请先完善回函地址、函证联系人信息、回函传真" : "",
      type: "primary"
    },
    on: {
      click: _vm.updateTemplate
    }
  }, [_vm._v("编辑 ")])], 1)], 1) : _vm._e()])], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "自编函证上传"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("自编函证上传")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "如系统没有适配的函证模板，可自行制作函证转换为pdf格式并上传到此处。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("div", {
    staticClass: "form-item-content-wrap"
  }, [_c("div", {
    staticClass: "left"
  }, [_vm.baseForm.c02SendFile1 ? _c("el-popover", {
    attrs: {
      placement: "top-start",
      width: "200",
      trigger: "hover"
    }
  }, [_c("span", {
    staticClass: "view-detail",
    staticStyle: {
      "font-size": "12px"
    },
    on: {
      click: function click($event) {
        return _vm.getFileUrl(_vm.baseForm.c02SendFile1, "自编函证");
      }
    }
  }, [_vm._v(_vm._s(_vm.baseForm.c02SendFile1))]), _c("span", {
    attrs: {
      slot: "reference"
    },
    slot: "reference"
  }, [_c("cpsc-icon", {
    attrs: {
      hover: true,
      name: "el-icon-view"
    }
  })], 1)]) : _vm._e()], 1), _vm.stepActive === 0 ? _c("div", {
    staticClass: "left text-right form-item-content-wrap"
  }, [_c("cpsc-file-upload", {
    staticClass: "left",
    attrs: {
      "show-list": false,
      clear: true,
      accept: ".pdf,.PDF,.png,.jpg,.jpeg,.bmp,.webp,.docx,.xlsx",
      type: "text"
    },
    on: {
      change: _vm.fileChange
    }
  }), _vm.baseForm.c02SendFile1 ? _c("el-button", {
    staticClass: "right",
    attrs: {
      size: "mini",
      disabled: !(_vm.stepActive === 0 && _vm.isGroup),
      type: "text"
    },
    on: {
      click: _vm.removeFile1
    }
  }, [_vm._v("删除 ")]) : _vm._e()], 1) : _vm._e()])])], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "插件推送附件"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("插件推送附件")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "针对插件端生成的往来、存货、工程、其他类型的函证可打印件(PDF)，在置已发时点，将推送到此处(发电子函证全推，非电子函证仅推送其他类型[需合并附件或编辑数据区域]的函证)",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _vm.baseForm.c02SendFile2 ? _c("el-popover", {
    attrs: {
      placement: "top-start",
      width: "200",
      trigger: "hover"
    }
  }, [_c("div", {
    staticClass: "view-wrap"
  }, [_c("p", {
    staticClass: "view-detail",
    on: {
      click: function click($event) {
        return _vm.getFileUrl2(false, "c02SendFile2");
      }
    }
  }, [_vm._v(" 插件推送附件 ")]), _c("p", {
    staticClass: "view-detail download",
    on: {
      click: function click($event) {
        return _vm.getFileUrl2(true, "c02SendFile2");
      }
    }
  }, [_vm._v("下载")])]), _c("span", {
    attrs: {
      slot: "reference"
    },
    slot: "reference"
  }, [_c("cpsc-icon", {
    attrs: {
      hover: true,
      name: "el-icon-view"
    }
  })], 1)]) : _vm._e()], 1)], 1)], 1), _c("el-row", {
    staticClass: "row",
    attrs: {
      align: "top",
      gutter: 30,
      type: "flex"
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "函证收件地址",
      prop: "c02ObjAddress"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("快递发函收件地址")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "请正确录入从被审客户处获取的被函证对象的发函地址，函证发出前，请执行该地址与被函证对象工商注册地址的距离，并核验地址的正确性及有效性。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("el-input", {
    staticClass: "app-form-component-select",
    attrs: {
      placeholder: "请输入函证收件地址",
      maxlength: 100,
      "show-word-limit": ""
    },
    model: {
      value: _vm.baseForm.c02ObjAddress,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02ObjAddress", $$v);
      },
      expression: "baseForm.c02ObjAddress"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "函证收件人",
      prop: "c02ObjStaff"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v(" 函证收件人(纸函)/银行账号(银行电函) ")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "请正确录入从被审客户处获取的被函证对象的收件人，函证发出前，需在插件中执行与被审单位内部人员比对操作，消除内部人员接收函证风险。如发送电子函证需确保姓名正确",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("el-input", {
    staticClass: "app-form-component-select",
    attrs: {
      disabled: !(_vm.stepActive === 0 && _vm.isGroup),
      maxlength: 50,
      placeholder: "请输入函证收件人"
    },
    model: {
      value: _vm.baseForm.c02ObjStaff,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02ObjStaff", $$v);
      },
      expression: "baseForm.c02ObjStaff"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "收函人电话",
      prop: "c02ObjMobile"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("函证收件人电话(纸函)/银行联行号(银行电函)")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "请正确录入从被审客户处获取的被函证对象的收件人电话，尽量获取固定电话，如发送电子函证，需使用收件人的手机号码。函证发出前，需在插件中执行与被审单位内部人员电话比对操作，消除内部人员接收函证风险。如发送电子函证需用手机号",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("el-input", {
    staticClass: "app-form-component-select",
    attrs: {
      disabled: !(_vm.stepActive === 0 && _vm.isGroup),
      maxlength: 50,
      placeholder: "请输入函证收件人电话"
    },
    model: {
      value: _vm.baseForm.c02ObjMobile,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02ObjMobile", $$v);
      },
      expression: "baseForm.c02ObjMobile"
    }
  })], 1)], 1)], 1), _c("el-row", {
    staticClass: "row",
    attrs: {
      align: "top",
      gutter: 30,
      type: "flex"
    }
  }, [_c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "函证审核人姓名/对应银行名称",
      prop: "c02ObjTel"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("函证审核人姓名/对应银行名称")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "非银行函证通过币码发送电子函证，此处为被审单位函证审核人姓名；银行函证发函，此处为对应银行名称",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("el-input", {
    staticClass: "app-form-component-select",
    attrs: {
      disabled: !((_vm.stepActive === 0 || _vm.stepActive === 2) && _vm.isGroup),
      placeholder: "函证审核人姓名/对应银行名称"
    },
    model: {
      value: _vm.baseForm._c02ObjTelName,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "_c02ObjTelName", $$v);
      },
      expression: "baseForm._c02ObjTelName"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "函证审核人手机/银行发函格式",
      prop: "c02ObjTel"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("函证审核人手机/银行发函格式")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "非银行函证通过币码发送电子函证，此处为被审单位函证审核人手机号；银行函证发函，此处为发函格式(格式一or格式二)",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("el-input", {
    staticClass: "app-form-component-select",
    attrs: {
      disabled: !((_vm.stepActive === 0 || _vm.stepActive === 2) && _vm.isGroup),
      placeholder: "函证审核人手机/银行发函格式"
    },
    model: {
      value: _vm.baseForm._c02ObjTelPhone,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "_c02ObjTelPhone", $$v);
      },
      expression: "baseForm._c02ObjTelPhone"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "发函信息核验人",
      prop: "c02CheckStaffName"
    }
  }, [_c("el-input", {
    staticClass: "app-form-component-select",
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.baseForm.c02CheckStaffName,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02CheckStaffName", $$v);
      },
      expression: "baseForm.c02CheckStaffName"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "发函信息核验日期",
      prop: "c02CheckDate"
    }
  }, [_c("el-date-picker", {
    staticClass: "app-form-component-select",
    attrs: {
      type: "date",
      disabled: "",
      "value-format": "yyyy-MM-dd",
      placeholder: "发函信息核验日期"
    },
    model: {
      value: _vm.baseForm.c02CheckDate,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02CheckDate", $$v);
      },
      expression: "baseForm.c02CheckDate"
    }
  })], 1)], 1)], 1), _c("el-row", {
    staticClass: "row",
    attrs: {
      align: "top",
      gutter: 30,
      type: "flex"
    }
  }, [_c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "地址核查方式",
      prop: "c02CheckType"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("注册vs收件地址核查方式(人工/第三方)")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "指定人工方式需写明核查过程并指定核查结论，选择天地图，将在核查过程中自动记录接口返回数据。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("cpsc-select", {
    staticClass: "select",
    attrs: {
      disabled: !(_vm.stepActive === 0 && _vm.isGroup),
      filterable: "",
      placeholder: "请选择"
    },
    on: {
      change: _vm.c02CheckTypeChange
    },
    model: {
      value: _vm.baseForm.c02CheckType,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02CheckType", $$v);
      },
      expression: "baseForm.c02CheckType"
    }
  }, _vm._l(_vm.checkTypes, function (item) {
    return _c("el-option", {
      key: item.text,
      attrs: {
        label: item.text,
        disabled: item.disabled,
        value: item.text
      }
    });
  }), 1)], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "注册收函地址距离",
      prop: "c02CheckDistance"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("注册vs收件地址距离(人工/第三方)")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "调用第三方接口，计算并返回注册地址与函证收件地址的距离，本数据仅作为参考辅助函证风险判断。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("div", {
    staticClass: "form-item-content-wrap"
  }, [_c("div", {
    staticClass: "left ellipsis",
    attrs: {
      title: _vm.$options.filters.km(_vm.baseForm.c02CheckDistance)
    }
  }, [_vm._v(_vm._s(_vm._f("km")(_vm.baseForm.c02CheckDistance)))]), _vm.objForm.c03CorrectAddress ? _c("div", {
    staticClass: "right"
  }, [_c("el-button", {
    attrs: {
      size: "mini",
      disabled: !(_vm.stepActive === 0 && _vm.isGroup),
      type: "text"
    },
    on: {
      click: function click($event) {
        return _vm.viewMap("computed");
      }
    }
  }, [_vm._v("计算 ")]), _c("el-button", {
    attrs: {
      size: "mini",
      type: "text"
    },
    on: {
      click: function click($event) {
        return _vm.viewMap("view");
      }
    }
  }, [_vm._v("查看")])], 1) : _vm._e()])])], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "注册vs收件地址核查过程说明",
      prop: "c02CheckProcess"
    }
  }, [_c("div", {
    staticClass: "form-item-content-wrap"
  }, [_c("preview-html", {
    staticClass: "left",
    attrs: {
      placement: "bottom",
      content: _vm.baseForm.c02CheckProcess
    }
  }), _c("div", {
    staticClass: "right text-right"
  }, [_c("el-button", {
    attrs: {
      size: "mini",
      type: "primary",
      disabled: !(_vm.stepActive === 0 && _vm.isGroup)
    },
    on: {
      click: function click($event) {
        return _vm.changeRecord("baseForm", "c02CheckProcess");
      }
    }
  }, [_vm._v("编辑 ")])], 1)], 1)])], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "地址核查结论",
      prop: "c02CheckConclusion"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("注册vs收件地址核查结论")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "如注册与收函地址距离差异较大，会将地址核查结论指定为异常，需对收函地址进行核查并在核查过程说明中进行描述。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("cpsc-select", {
    staticClass: "select",
    attrs: {
      disabled: !(_vm.stepActive === 0 && _vm.isGroup),
      placeholder: "请选择"
    },
    model: {
      value: _vm.baseForm.c02CheckConclusion,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02CheckConclusion", $$v);
      },
      expression: "baseForm.c02CheckConclusion"
    }
  }, [_c("el-option", {
    attrs: {
      label: "正常",
      value: "正常"
    }
  }), _c("el-option", {
    attrs: {
      label: "异常",
      value: "异常"
    }
  })], 1)], 1)], 1)], 1), _c("el-row", {
    staticClass: "row",
    attrs: {
      align: "top",
      gutter: 30,
      type: "flex"
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "函证回函地址",
      prop: "c02ReturnAddress"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("快递回函邮寄地址(事务所函证中心)")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "指定函证回函的邮寄地址，一般为事务所函证中心的收件地址。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("el-input", {
    staticClass: "app-form-component-select",
    attrs: {
      disabled: !(_vm.stepActive === 0 && _vm.isGroup),
      maxlength: 100,
      "show-word-limit": "",
      placeholder: "请输入快递回函邮寄地址"
    },
    model: {
      value: _vm.baseForm.c02ReturnAddress,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02ReturnAddress", $$v);
      },
      expression: "baseForm.c02ReturnAddress"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "快递回函收件人姓名/电话",
      prop: "c02ReturnMobile"
    }
  }, [_c("el-input", {
    staticClass: "app-form-component-select",
    attrs: {
      disabled: !(_vm.stepActive === 0 && _vm.isGroup),
      placeholder: "请输入快递回函收件人姓名/电话"
    },
    model: {
      value: _vm.baseForm.c02ReturnMobile,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02ReturnMobile", $$v);
      },
      expression: "baseForm.c02ReturnMobile"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "事务所传真",
      prop: "c02ReturnFax"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("事务所传真回函号码")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "指定通过传真方式回函的事务所传真号码。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("el-input", {
    staticClass: "app-form-component-select",
    attrs: {
      disabled: !(_vm.stepActive === 0 && _vm.isGroup),
      placeholder: "请输入事务所传真回函号码"
    },
    model: {
      value: _vm.baseForm.c02ReturnFax,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02ReturnFax", $$v);
      },
      expression: "baseForm.c02ReturnFax"
    }
  })], 1)], 1)], 1), _c("el-row", {
    staticClass: "row",
    attrs: {
      align: "top",
      gutter: 30,
      type: "flex"
    }
  }, [_c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "函证问题联系人",
      prop: "_c02ReturnStaff"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("函证问题联系人(项目组成员姓名)")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "执行函证回函过程中，针对函证数据问题需要联系的项目组人员姓名。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("el-input", {
    staticClass: "app-form-component-select",
    attrs: {
      disabled: !(_vm.stepActive === 0 && _vm.isGroup),
      placeholder: "请输入函证问题联系人"
    },
    model: {
      value: _vm.baseForm._c02ReturnStaff,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "_c02ReturnStaff", $$v);
      },
      expression: "baseForm._c02ReturnStaff"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "联系人电话",
      prop: "_c02ReturnStaffPhone"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("函证问题联系人电话")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "执行函证回函过程中，针对函证数据问题需要联系的项目组人员的电话号码。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("el-input", {
    staticClass: "app-form-component-select",
    attrs: {
      disabled: !(_vm.stepActive === 0 && _vm.isGroup),
      placeholder: "请输入函证问题联系人电话"
    },
    model: {
      value: _vm.baseForm._c02ReturnStaffPhone,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "_c02ReturnStaffPhone", $$v);
      },
      expression: "baseForm._c02ReturnStaffPhone"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "联系人邮箱",
      prop: "c02ReturnMail"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("函证问题联系人邮箱")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "执行函证回函过程中，针对函证数据问题需要联系的项目组人员的电子邮箱，也可作为电子邮件回函的收件邮箱。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("el-input", {
    staticClass: "app-form-component-select",
    attrs: {
      disabled: !(_vm.stepActive === 0 && _vm.isGroup),
      placeholder: "请输入函证问题联系人邮箱"
    },
    model: {
      value: _vm.baseForm.c02ReturnMail,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02ReturnMail", $$v);
      },
      expression: "baseForm.c02ReturnMail"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "发函信息审核人/日期",
      prop: "c02AuditName"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("发函信息审核人/日期")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "在函证中心系统执行函证流程中针对函证基础信息进行审核的项目负责人姓名和审核日期，通过插件方式推送函证基础信息，此项为空，默认项目负责人对插件数据进行了审核。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("el-input", {
    attrs: {
      readonly: true,
      value: "".concat((_vm$baseForm$c02Audit = _vm.baseForm.c02AuditName) !== null && _vm$baseForm$c02Audit !== void 0 ? _vm$baseForm$c02Audit : "", "/").concat(_vm.$options.filters.date(_vm.baseForm.c02AuditDate, "yyyy-MM-dd"))
    }
  })], 1)], 1)], 1)], 1)]), _c("div", {
    ref: "step-2",
    staticClass: "box"
  }, [_c("div", {
    staticClass: "box-type"
  }, [_vm._v(" 发函过程记录"), _vm.stepActive !== 2 && _vm.stepTwoPermissions ? _c("span", [_vm._v("(只读)")]) : _vm._e()]), _c("div", {
    staticClass: "box-content remove-form-disabled-style"
  }, [_c("el-row", {
    staticClass: "row",
    attrs: {
      align: "top",
      gutter: 30,
      type: "flex"
    }
  }, [_c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "发函方式",
      prop: "c02SendType"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("函证发出方式")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "请指定正确的发函方式。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("cpsc-select", {
    staticClass: "select",
    attrs: {
      filterable: "",
      disabled: !(_vm.stepActive === 2 && _vm.stepTwoPermissions),
      placeholder: "请选择函证发出方式"
    },
    on: {
      change: _vm.sendTypeChange
    },
    model: {
      value: _vm.baseForm.c02SendType,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02SendType", $$v);
      },
      expression: "baseForm.c02SendType"
    }
  }, _vm._l(_vm.correspondenceTypes, function (item) {
    return _c("el-option", {
      key: item.n04Id,
      attrs: {
        label: item.n04Value,
        value: item.n04Value
      }
    });
  }), 1)], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "发函/跟函人",
      prop: "c02SendStaff"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("发函(跟函)人")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "如为项目组人员发函或跟函，请写明项目组[人员姓名]；如为函证中心发函，请写明函证中心[人员姓名]。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("el-input", {
    staticClass: "app-form-component-select",
    attrs: {
      disabled: !(_vm.stepActive === 2 && _vm.stepTwoPermissions),
      placeholder: "项目组[姓名]或函证中心[姓名]"
    },
    model: {
      value: _vm.baseForm.c02SendStaff,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02SendStaff", $$v);
      },
      expression: "baseForm.c02SendStaff"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "发函/跟函日期",
      prop: "c02SendDate"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("发函/跟函日期")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "请指定函证发出或跟函的日期。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("el-date-picker", {
    staticClass: "app-form-component-select",
    attrs: {
      type: "date",
      clearable: "",
      disabled: !(_vm.stepActive === 2 && _vm.stepTwoPermissions),
      "value-format": "yyyy-MM-dd",
      placeholder: "请选择发函/跟函日期"
    },
    on: {
      change: _vm.sendDateChange
    },
    model: {
      value: _vm.baseForm.c02SendDate,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02SendDate", $$v);
      },
      expression: "baseForm.c02SendDate"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "函证发出/跟函地点",
      prop: "c02SendAddress"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("函证(跟函)地点或方式")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "[邮寄发函]请写明函证寄出地点；[人员跟函]请写明跟函地点；其他方式请写明发函方式：电子邮件请写发出邮箱，传真请写发出函证的传真号码，电子函证请写对接币码发送电子函证等。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("el-input", {
    staticClass: "app-form-component-select",
    attrs: {
      disabled: !(_vm.stepActive === 2 && _vm.stepTwoPermissions),
      placeholder: "所内、项目驻地酒店、电邮、传真号、网站等"
    },
    model: {
      value: _vm.baseForm.c02SendAddress,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02SendAddress", $$v);
      },
      expression: "baseForm.c02SendAddress"
    }
  })], 1)], 1)], 1), _c("el-row", {
    staticClass: "row",
    attrs: {
      align: "top",
      gutter: 30,
      type: "flex"
    }
  }, [_c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "发函/跟函记录",
      prop: "c02SendProcess"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("发函(跟函)过程记录")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "请针对不同发函方式，简要描述发函控制过程，确保项目组对函证的发出控制过程有效可控。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("div", {
    staticClass: "form-item-content-wrap"
  }, [_c("preview-html", {
    staticClass: "left",
    attrs: {
      placement: "right-start",
      content: _vm.baseForm.c02SendProcess
    }
  }), _c("div", {
    staticClass: "right text-right"
  }, [_c("el-button", {
    attrs: {
      size: "mini",
      type: "primary",
      disabled: !(_vm.stepActive === 2 && _vm.stepTwoPermissions)
    },
    on: {
      click: function click($event) {
        return _vm.changeRecord("baseForm", "c02SendProcess");
      }
    }
  }, [_vm._v("编辑 ")])], 1)], 1)])], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "快递公司",
      prop: "c02SendCompany"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("邮寄发函快递公司")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "如为邮寄发函，请查选快递公司简称并下拉指定。如为其他发函方式，请选择[N/A]。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("cpsc-select", {
    staticClass: "select",
    attrs: {
      filterable: "",
      disabled: !(_vm.stepActive === 2 && _vm.stepTwoPermissions),
      data: _vm.sendCompany,
      "is-filter": true,
      "filter-name": "text",
      "filter-code": "code",
      clearable: "",
      "default-data-items": _vm.defaultDataItems,
      placeholder: "请选择邮寄发函快递公司"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var data = _ref.data;
        return _vm._l(data, function (item) {
          return _c("el-option", {
            key: item.code,
            attrs: {
              label: item.text,
              value: item.text
            }
          });
        });
      }
    }]),
    model: {
      value: _vm.baseForm.c02SendCompany,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02SendCompany", $$v);
      },
      expression: "baseForm.c02SendCompany"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "快递单号",
      prop: "c02SendNumber"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("邮寄发函快递单号")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "如为邮寄发函，请输入(手工/扫描枪)快递单号。如为其他发函方式，请输入[N/A]。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)]), _vm.isHX && _vm.isSendSFKD && (_vm.isCpscAdmin || _vm.isSender || _vm.isreplyPersonnel || _vm.isGroup || _vm.roles.includes("查询")) && _vm.isHZTData ? _c("el-button", {
    staticClass: "type4",
    attrs: {
      size: "mini",
      loading: _vm.expressLoading,
      disabled: !_vm.baseForm.c02ConfirmCode,
      type: "text"
    },
    on: {
      click: _vm.getHZTRecord
    }
  }, [_vm._v("函证通下单记录 ")]) : _vm._e(), _vm.canBeSearchExpress ? _c("el-popover", {
    attrs: {
      disabled: !_vm.baseData.c02SendNumber,
      placement: "top-start",
      title: "寄件人手机号码后4位",
      width: "320",
      trigger: "hover"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "寄件人手机号码后4位",
      maxlength: 4
    },
    model: {
      value: _vm.expressNo_Send,
      callback: function callback($$v) {
        _vm.expressNo_Send = typeof $$v === "string" ? $$v.trim() : $$v;
      },
      expression: "expressNo_Send"
    }
  }), _c("span", {
    attrs: {
      slot: "reference"
    },
    slot: "reference"
  }, [_vm.isSendSFKD && (_vm.isSender || _vm.isreplyPersonnel || _vm.isCpscAdmin || _vm.isGroup || _vm.roles.includes("查询")) ? _c("el-button", {
    staticClass: "type2",
    attrs: {
      size: "mini",
      disabled: !_vm.expressNo_Send,
      loading: _vm.expressLoading,
      type: "text"
    },
    on: {
      click: function click($event) {
        return _vm.getHZTInfo2("send");
      }
    }
  }, [_vm._v("获取顺丰物流数据 ")]) : _vm._e()], 1)], 1) : _vm._e()], 1), _c("div", {
    staticClass: "form-item-content-wrap"
  }, [_c("div", {
    staticClass: "left ellipsis"
  }, [_c("el-input", {
    staticClass: "app-form-component-select",
    attrs: {
      disabled: !(_vm.stepActive === 2 && _vm.stepTwoPermissions),
      placeholder: "请输入邮寄发函快递单号"
    },
    model: {
      value: _vm.baseForm.c02SendNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02SendNumber", $$v);
      },
      expression: "baseForm.c02SendNumber"
    }
  })], 1), _c("div", {
    staticClass: "right"
  }, [_vm.canBeSearchExpress ? _c("el-popover", {
    attrs: {
      disabled: !_vm.baseData.c02SendNumber,
      placement: "top-start",
      title: "电话号码后4位(针对顺丰部分情况下无法查询物流信息)",
      width: "320",
      trigger: "hover"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "电话号码后4位",
      maxlength: 4
    },
    model: {
      value: _vm.expressNo_Send,
      callback: function callback($$v) {
        _vm.expressNo_Send = $$v;
      },
      expression: "expressNo_Send"
    }
  }), _c("el-button", {
    attrs: {
      slot: "reference",
      size: "mini",
      loading: _vm.expressLoading,
      type: "text"
    },
    on: {
      click: function click($event) {
        return _vm.getExpressInfo("send", _vm.stepTwoPermissions || _vm.isreplyPersonnel);
      }
    },
    slot: "reference"
  }, [_vm._v("快递100物流路由 ")])], 1) : _c("el-popover", {
    attrs: {
      placement: "top-start",
      title: "提示",
      width: "320",
      trigger: "hover"
    }
  }, [_c("div", {
    staticClass: "express-btn-tips"
  }, [_c("p", [_vm._v(" 请确认下列数据已填写完整并已点击保存按钮 ")]), _c("ul", [_c("li", [_vm._v("快递发函收件地址")]), _c("li", [_vm._v("函证(跟函)地点或方式")]), _c("li", [_vm._v("邮寄发函快递公司")]), _c("li", [_vm._v("邮寄发函快递单号")])])]), _c("el-button", {
    attrs: {
      slot: "reference",
      size: "mini",
      loading: _vm.expressLoading,
      type: "text"
    },
    slot: "reference"
  }, [_vm._v("快递100物流路由 ")])], 1), _vm.isSendSFKD && (_vm.isSender || _vm.isCpscAdmin || _vm.isGroup || _vm.roles.includes("查询")) ? _c("el-button", {
    staticClass: "type3",
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      size: "mini",
      disabled: !_vm.baseForm.c02SendNumber,
      loading: _vm.expressLoading,
      type: "text"
    },
    on: {
      click: _vm.getSendHZTLogistics
    }
  }, [_vm._v("顺丰物流路由 ")]) : _vm._e()], 1)])])], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "发函快递面单附件",
      prop: "c02BackWaybill"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("邮寄发函快递面单附件")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "如为邮寄发函，可上传快递面单电子版备存于系统（非必须上传项）。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("div", {
    staticClass: "form-item-content-wrap"
  }, [_c("div", {
    staticClass: "left"
  }, [_vm.baseForm.c02SendWaybill ? _c("el-popover", {
    attrs: {
      placement: "top-start",
      width: "200",
      trigger: "hover"
    }
  }, [_c("div", {
    staticClass: "view-wrap"
  }, [_c("p", {
    staticClass: "view-detail",
    on: {
      click: function click($event) {
        return _vm.getFileUrl2(false, "c02SendWaybill");
      }
    }
  }, [_vm._v(_vm._s(_vm.c02SendWaybillName))]), _c("p", {
    staticClass: "view-detail download",
    on: {
      click: function click($event) {
        return _vm.getFileUrl2(true, "c02SendWaybill");
      }
    }
  }, [_vm._v("下载")])]), _c("span", {
    attrs: {
      slot: "reference"
    },
    slot: "reference"
  }, [_c("cpsc-icon", {
    attrs: {
      hover: true,
      name: "el-icon-view"
    }
  })], 1)]) : _vm._e()], 1), _vm.stepActive === 2 && _vm.stepTwoPermissions ? _c("div", {
    staticClass: "left text-right form-item-content-wrap"
  }, [_c("el-popover", {
    attrs: {
      placement: "top-start",
      title: "文件上传",
      width: "200",
      trigger: "hover"
    }
  }, [_c("div", {
    staticClass: "file-flex-wrap"
  }, [_c("cpsc-file-upload", {
    staticClass: "left",
    attrs: {
      clear: true,
      accept: ".pdf,.jpg,.png,.zip",
      "show-list": false,
      "btn-text": "本地上传",
      type: "text"
    },
    on: {
      change: function change(files) {
        return _vm.waybillFileChange(files, "c02SendWaybill");
      }
    }
  }), _c("el-button", {
    staticClass: "right type2",
    attrs: {
      type: "text",
      size: "mini"
    },
    on: {
      click: function click($event) {
        return _vm.showAltimeter(1, "邮寄发函快递面单附件");
      }
    }
  }, [_vm._v("高拍仪上传")])], 1), _c("el-button", {
    attrs: {
      slot: "reference",
      type: "text",
      size: "mini"
    },
    slot: "reference"
  }, [_vm._v("文件上传")])], 1), _vm.baseForm.c02SendWaybill && _vm.stepTwoPermissions ? _c("el-button", {
    staticClass: "right",
    attrs: {
      size: "mini",
      type: "text"
    },
    on: {
      click: function click($event) {
        return _vm.removeBackConfirmFile("c02SendWaybill");
      }
    }
  }, [_vm._v("删除 ")]) : _vm._e()], 1) : _vm._e()])])], 1)], 1), _c("el-row", {
    staticClass: "row",
    attrs: {
      align: "top",
      gutter: 30,
      type: "flex"
    }
  }, [_c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "发函费用及所属",
      prop: "c02SendBelong"
    }
  }, [_c("div", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v(" 邮寄发函费用及所属 ")]), _c("el-popover", {
    attrs: {
      placement: "top-start",
      title: "提示",
      width: "450",
      trigger: "hover"
    }
  }, [_c("div", [_c("p", [_vm._v(" 发函费用：如为邮寄发函且产生发函费用，该费用由项目组或事务所垫付，请输入该费用金额。如已由客户支付或使用其他发函方式，请输入0。 ")]), _c("p", [_vm._v(" 费用所属：如为邮寄发函且产生发函费用，该费用由项目组或事务所垫付，请指定归属[被审客户]或[本所部组]，否则请指定[不适用]。 ")])]), _c("span", {
    attrs: {
      slot: "reference"
    },
    slot: "reference"
  }, [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("div", {
    staticClass: "flex-wrap obj-tel"
  }, [_c("div", {
    staticClass: "left"
  }, [_c("el-input", {
    staticClass: "app-form-component-select",
    attrs: {
      type: "number",
      disabled: !(_vm.stepActive === 2 && _vm.stepTwoPermissions),
      placeholder: "请输入发函费用"
    },
    model: {
      value: _vm.baseForm.c02SendFee,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02SendFee", $$v);
      },
      expression: "baseForm.c02SendFee"
    }
  })], 1), _c("div", {
    staticClass: "right"
  }, [_c("cpsc-select", {
    staticClass: "select",
    attrs: {
      filterable: "",
      clearable: "",
      disabled: !(_vm.stepActive === 2 && _vm.stepTwoPermissions),
      placeholder: "请选择费用所属"
    },
    model: {
      value: _vm.baseForm.c02SendBelong,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02SendBelong", $$v);
      },
      expression: "baseForm.c02SendBelong"
    }
  }, _vm._l(_vm.costTypes, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.name,
        value: item.value
      }
    });
  }), 1)], 1)])])], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "费用回收状态",
      prop: "c02SendFeeStatus"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("归属客户费用回收状态")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "如为邮寄发函且产生发函费用，该费用由项目组或事务所垫付，且指定归属[被审客户]，请指定为[待结算]。后续根据费用收回变更为[已回收]。否则请指定为[不适用]。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("cpsc-select", {
    staticClass: "select",
    attrs: {
      disabled: !(_vm.stepActive === 2 && _vm.stepTwoPermissions),
      filterable: "",
      clearable: "",
      placeholder: "请选择归属客户费用回收状态"
    },
    model: {
      value: _vm.baseForm.c02SendFeeStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02SendFeeStatus", $$v);
      },
      expression: "baseForm.c02SendFeeStatus"
    }
  }, _vm._l(_vm.costStates, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.name,
        value: item.value
      }
    });
  }), 1)], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "实际收件地址",
      prop: "c02SendRecAddress"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("邮寄发函物理轨迹收件地址")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "输入快递单号并保存后，点击[物流信息]按钮对接快递100接口(如配置)获取物流轨迹(系统永久保存)中的实际收件地址；或在快递公司官网查询物流轨迹后自行输入，并自行保存物流轨迹证据。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("el-input", {
    staticClass: "app-form-component-select",
    attrs: {
      maxlength: 100,
      disabled: !((_vm.stepActive === 2 || _vm.stepActive === 3) && (_vm.isGroup || _vm.isSender || _vm.isCpscAdmin || _vm.isreplyPersonnel)),
      placeholder: "请输入实际收件地址"
    },
    model: {
      value: _vm.baseForm.c02SendRecAddress,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02SendRecAddress", $$v);
      },
      expression: "baseForm.c02SendRecAddress"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "实际收件日期",
      prop: "c02SendRecDate"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("邮寄发函物理轨迹收件日期")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "输入快递单号并保存后，点击[物流信息]按钮对接快递100接口(如配置)获取物流轨迹(系统永久保存)中的实际收件日期；或在快递公司官网查询物流轨迹后自行输入，并自行保存物流轨迹证据。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("el-date-picker", {
    staticClass: "app-form-component-select",
    attrs: {
      type: "date",
      disabled: !((_vm.stepActive === 2 || _vm.stepActive === 3) && (_vm.isGroup || _vm.isSender || _vm.isCpscAdmin || _vm.isreplyPersonnel)),
      "value-format": "yyyy-MM-dd",
      placeholder: "请选择邮寄发函物理轨迹收件日期"
    },
    model: {
      value: _vm.baseForm.c02SendRecDate,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02SendRecDate", $$v);
      },
      expression: "baseForm.c02SendRecDate"
    }
  })], 1)], 1)], 1), _vm.baseForm.c02SendType === "电子函证" && _vm.baseForm.c02Extended ? [_c("el-row", {
    staticClass: "row",
    attrs: {
      align: "top",
      gutter: 30,
      type: "flex"
    }
  }, [_c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "币码ID",
      prop: ""
    }
  }, [_c("el-input", {
    attrs: {
      readonly: true,
      value: "".concat(_vm.baseForm.c02Extended.bimartId)
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "币码函证状态",
      prop: ""
    }
  }, [_c("el-input", {
    attrs: {
      readonly: true,
      value: "".concat(_vm.baseForm.c02Extended.currentProgress)
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "最后更新时间",
      prop: ""
    }
  }, [_c("el-input", {
    attrs: {
      readonly: true,
      value: "".concat(_vm.$options.filters.date(_vm.baseForm.c02Extended.lastUpdatedAt))
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "币码发函次数",
      prop: ""
    }
  }, [_c("el-input", {
    attrs: {
      readonly: true,
      value: "".concat(_vm.baseForm.c02Extended.repetitionCount)
    }
  })], 1)], 1)], 1), _c("el-row", {
    staticClass: "row",
    attrs: {
      align: "top",
      gutter: 30,
      type: "flex"
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "最近一次发函结果",
      prop: ""
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      rows: 3,
      readonly: true,
      value: "".concat(_vm.baseForm.c02Extended.detailedInfo)
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "上一次发函结果",
      prop: ""
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      rows: 3,
      readonly: true,
      value: "".concat(_vm.baseForm.c02Extended.historyDetailedInfo)
    }
  })], 1)], 1)], 1)] : _vm._e()], 2)]), _c("div", {
    ref: "step-3",
    staticClass: "box"
  }, [_c("div", {
    staticClass: "box-type"
  }, [_vm._v(" 回函过程记录"), _vm.baseForm.c02SendFrequency ? [_vm._v("[已发" + _vm._s(_vm.baseForm.c02SendFrequency) + "次]")] : _vm._e(), (_vm.cpsccAdminPermissions ? !_vm.cpsccAdminPermissions : _vm.stepActive !== 3 && _vm.stepThreePermissions) ? _c("span", [_vm._v("(只读)")]) : _vm._e()], 2), _c("div", {
    staticClass: "box-content remove-form-disabled-style"
  }, [_c("el-row", {
    staticClass: "row",
    attrs: {
      align: "top",
      gutter: 30,
      type: "flex"
    }
  }, [_c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "回函方式",
      prop: "c02BackType"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("回函方式")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "正确指定回函方式，项目组维护邮寄回函需指定项目组邮件",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("cpsc-select", {
    staticClass: "select",
    attrs: {
      disabled: _vm.c02BackTypePermission,
      filterable: "",
      placeholder: "请选择回函方式"
    },
    on: {
      change: _vm.backTypeChange
    },
    model: {
      value: _vm.baseForm.c02BackType,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02BackType", $$v);
      },
      expression: "baseForm.c02BackType"
    }
  }, _vm._l(_vm.reTypes, function (item) {
    return _c("el-option", {
      key: item,
      attrs: {
        label: item,
        disabled: item === "函证中心邮件" && !_vm.isCpscAdmin && !_vm.isreplyPersonnel,
        value: item
      }
    });
  }), 1)], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "回函签署日期",
      prop: "c02BackConfirmDate"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("回函签署日期")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "指定纸质函证上由回函人签署的日期，如未签署，请指定函件寄出日期",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("div", {
    staticClass: "tmp-flex-wrap"
  }, [_c("div", {
    staticClass: "left"
  }, [_c("el-date-picker", {
    staticClass: "app-form-component-select",
    attrs: {
      disabled: _vm.cpsccAdminPermissions ? !_vm.cpsccAdminPermissions : !(_vm.stepActive === 3 && _vm.stepThreePermissions),
      type: "date",
      "value-format": "yyyy-MM-dd",
      placeholder: "请选择回函签署日期"
    },
    model: {
      value: _vm.baseForm.c02BackConfirmDate,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02BackConfirmDate", $$v);
      },
      expression: "baseForm.c02BackConfirmDate"
    }
  })], 1), _c("div", {
    staticClass: "right"
  }, [_vm.showBackConfirmDateTips && _vm.stepActive === 3 && _vm.stepThreePermissions ? _c("el-tooltip", {
    staticClass: "item",
    attrs: {
      effect: "dark",
      content: "函证回函日期晚于今天，请务必核实该日期是否正确",
      value: true,
      manual: true,
      disabled: !_vm.showBackConfirmDateTips,
      placement: "top"
    }
  }, [_c("i", {
    staticClass: "icon el-icon-warning error"
  })]) : _vm._e()], 1)])])], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "函证结论",
      prop: "c02BackConfirmConclusion"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("函证结论(相符/不符)")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "根据函证上的盖章位置及描述情况确定函证结论是否相符",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("el-radio-group", {
    attrs: {
      disabled: _vm.cpsccAdminPermissions ? !_vm.cpsccAdminPermissions : !(_vm.stepActive === 3 && _vm.stepThreePermissions)
    },
    model: {
      value: _vm.baseForm.c02BackConfirmConclusion,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02BackConfirmConclusion", $$v);
      },
      expression: "baseForm.c02BackConfirmConclusion"
    }
  }, [_c("el-radio-button", {
    attrs: {
      label: "相符"
    }
  }), _c("el-radio-button", {
    attrs: {
      label: "不符"
    }
  })], 1)], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "函证初判",
      prop: "c02BackConfirmValid"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("函证初判(正常/异常)")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "根据回函整体情况判断该函证回函是否存在异常，如为异常，请在回函检查说明中文字描述",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("el-radio-group", {
    attrs: {
      disabled: _vm.cpsccAdminPermissions ? !_vm.cpsccAdminPermissions : !(_vm.stepActive === 3 && _vm.stepThreePermissions)
    },
    model: {
      value: _vm.baseForm.c02BackConfirmValid,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02BackConfirmValid", $$v);
      },
      expression: "baseForm.c02BackConfirmValid"
    }
  }, [_c("el-radio-button", {
    attrs: {
      label: "正常"
    }
  }), _c("el-radio-button", {
    attrs: {
      label: "异常"
    }
  }), _c("el-radio-button", {
    attrs: {
      label: "未验"
    }
  })], 1)], 1)], 1)], 1), _c("el-row", {
    staticClass: "row",
    attrs: {
      align: "top",
      gutter: 30,
      type: "flex"
    }
  }, [_c("el-col", {
    attrs: {
      span: _vm.baseForm.c02BackConfirmExplain === "0" ? 6 : 12
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "回函检查说明",
      prop: ""
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("回函检查说明")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "函证中心针对回函的整体情况进行检查并描述函证初判异常或地址异常情况，以清晰提示项目组；或由项目组对非统一处理的回函整体情况进行检查并描述函证异常情况。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("cpsc-select", {
    staticClass: "select",
    attrs: {
      filterable: "",
      disabled: _vm.cpsccAdminPermissions ? !_vm.cpsccAdminPermissions : !(_vm.stepActive === 3 && _vm.stepThreePermissions),
      placeholder: "针对地址异常、函证初判异常, 请简要说明相关情况"
    },
    model: {
      value: _vm.baseForm.c02BackConfirmExplain,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02BackConfirmExplain", $$v);
      },
      expression: "baseForm.c02BackConfirmExplain"
    }
  }, _vm._l(_vm.backConfirmExplainList, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: "".concat(item.value, ":").concat(item.label),
        value: item.value
      }
    });
  }), 1)], 1)], 1), _vm.baseForm.c02BackConfirmExplain === "0" ? _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "异常说明",
      prop: "_c02BackConfirmExplain"
    }
  }, [_c("el-input", {
    staticClass: "app-form-component-select",
    attrs: {
      maxlength: 4000,
      disabled: _vm.cpsccAdminPermissions ? !_vm.cpsccAdminPermissions : !(_vm.stepActive === 3 && _vm.stepThreePermissions),
      placeholder: "针对地址异常、函证初判异常, 请简要说明相关情况"
    },
    model: {
      value: _vm.baseForm._c02BackConfirmExplain,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "_c02BackConfirmExplain", $$v);
      },
      expression: "baseForm._c02BackConfirmExplain"
    }
  })], 1)], 1) : _vm._e(), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "函证扫描附件",
      prop: "c02BackConfirmFile"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("纸质回函扫描件(其他回函附件)")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "指定本函证正确的扫描件文档执行上传，建议将函证扫描件与快递面单扫描件或者下载的pdf电子面单进行合并后上传到此处",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("div", {
    staticClass: "form-item-content-wrap"
  }, [_c("div", {
    staticClass: "left"
  }, [_vm.baseForm.c02BackConfirmFile ? _c("el-popover", {
    attrs: {
      placement: "top-start",
      width: "200",
      trigger: "hover"
    }
  }, [_c("div", {
    staticClass: "view-wrap"
  }, [_c("p", {
    staticClass: "view-detail",
    on: {
      click: function click($event) {
        return _vm.getFileUrl2(false);
      }
    }
  }, [_vm._v(_vm._s(_vm.backConfirmFileName))]), _c("p", {
    staticClass: "view-detail download",
    on: {
      click: function click($event) {
        return _vm.getFileUrl2(true);
      }
    }
  }, [_vm._v("下载")])]), _c("span", {
    attrs: {
      slot: "reference"
    },
    slot: "reference"
  }, [_c("cpsc-icon", {
    attrs: {
      hover: true,
      name: "el-icon-view"
    }
  })], 1)]) : _vm._e()], 1), (_vm.cpsccAdminPermissions ? _vm.cpsccAdminPermissions : _vm.stepActive === 3 && _vm.stepThreePermissions) ? _c("div", {
    staticClass: "left text-right form-item-content-wrap"
  }, [_c("el-popover", {
    attrs: {
      placement: "top-start",
      title: "文件上传",
      width: "200",
      trigger: "hover"
    }
  }, [_c("div", {
    staticClass: "file-flex-wrap"
  }, [_c("cpsc-file-upload", {
    staticClass: "left",
    attrs: {
      clear: true,
      accept: ".pdf,.jpg",
      "btn-text": "本地上传",
      "show-list": false,
      type: "text"
    },
    on: {
      change: _vm.backConfirmFileChange
    }
  }), _c("el-button", {
    staticClass: "right type2",
    attrs: {
      type: "text",
      size: "mini"
    },
    on: {
      click: function click($event) {
        return _vm.showAltimeter(2, "纸质回函扫描件");
      }
    }
  }, [_vm._v("高拍仪上传")])], 1), _c("el-button", {
    attrs: {
      slot: "reference",
      type: "text",
      size: "mini"
    },
    slot: "reference"
  }, [_vm._v("文件上传")])], 1), _vm.baseForm.c02BackConfirmFile && _vm.stepThreePermissions ? _c("el-button", {
    staticClass: "right",
    attrs: {
      size: "mini",
      type: "text"
    },
    on: {
      click: function click($event) {
        return _vm.removeBackConfirmFile("c02BackConfirmFile");
      }
    }
  }, [_vm._v("删除 ")]) : _vm._e()], 1) : _vm._e()])])], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "回函操作人/日期",
      prop: ""
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("回函操作人/日期")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "自动记录录入回函信息的人员姓名及日期。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-input", {
    attrs: {
      readonly: true,
      value: "".concat(_vm.baseForm.c02BackConfirmName)
    }
  })], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-date-picker", {
    staticClass: "app-form-component-select",
    attrs: {
      disabled: _vm.cpsccAdminPermissions ? !_vm.cpsccAdminPermissions : !(_vm.stepActive === 3 && _vm.stepThreePermissions),
      type: "date",
      "value-format": "yyyy-MM-dd",
      placeholder: "请选择回函操作日期"
    },
    model: {
      value: _vm.baseForm.c02BackConfirmOperateDate,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02BackConfirmOperateDate", $$v);
      },
      expression: "baseForm.c02BackConfirmOperateDate"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm.baseForm.c02BackType === "项目组邮件" || _vm.baseForm.c02BackType === "函证中心邮件" ? [_c("el-row", {
    staticClass: "row",
    attrs: {
      align: "top",
      gutter: 30,
      type: "flex"
    }
  }, [_c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "快递单号",
      prop: "c02BackNumber"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("邮寄回函快递单号")]), _c("el-tooltip", {
    staticClass: "mr-8",
    attrs: {
      slot: "label",
      effect: "dark",
      content: "请定位文本框，用扫描枪扫描快递条形码获取快递单号（推荐），或手工输入",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)]), _vm.isBackSFKD && (_vm.isreplyPersonnel || _vm.isSender || _vm.isCpscAdmin || _vm.isGroup || _vm.roles.includes("查询")) ? _c("el-button", {
    staticClass: "type2",
    attrs: {
      size: "mini",
      loading: _vm.expressLoading,
      type: "text"
    },
    on: {
      click: function click($event) {
        return _vm.getHZTInfo("reply");
      }
    }
  }, [_vm._v("获取顺丰物流数据 ")]) : _vm._e()], 1), _c("div", {
    staticClass: "form-item-content-wrap"
  }, [_c("div", {
    staticClass: "left ellipsis"
  }, [_c("el-input", {
    attrs: {
      placeholder: "邮寄回函快递单号",
      disabled: _vm.cpsccAdminPermissions ? !_vm.cpsccAdminPermissions : !(_vm.stepActive === 3 && _vm.stepThreePermissions)
    },
    on: {
      change: _vm.backNumberChange
    },
    model: {
      value: _vm.baseForm.c02BackNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02BackNumber", $$v);
      },
      expression: "baseForm.c02BackNumber"
    }
  })], 1), _c("div", {
    staticClass: "right"
  }, [_vm.canBeSearchExpress2 ? _c("el-popover", {
    attrs: {
      disabled: !_vm.baseData.c02BackNumber,
      placement: "top-start",
      title: "电话号码后4位(针对顺丰部分情况下无法查询物流信息)",
      width: "320",
      trigger: "hover"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "电话号码后4位",
      maxlength: 4
    },
    model: {
      value: _vm.expressNo_Back,
      callback: function callback($$v) {
        _vm.expressNo_Back = $$v;
      },
      expression: "expressNo_Back"
    }
  }), _c("el-button", {
    attrs: {
      slot: "reference",
      size: "mini",
      loading: _vm.expressLoading,
      type: "text"
    },
    on: {
      click: function click($event) {
        _vm.getExpressInfo("back", _vm.cpsccAdminPermissions ? _vm.cpsccAdminPermissions : _vm.stepActive === 3 && _vm.stepThreePermissions);
      }
    },
    slot: "reference"
  }, [_vm._v("快递100物流路由 ")])], 1) : _c("el-popover", {
    attrs: {
      placement: "top-start",
      title: "提示",
      width: "320",
      trigger: "hover"
    }
  }, [_c("div", {
    staticClass: "express-btn-tips"
  }, [_c("p", [_vm._v(" 请确认下列数据已填写完整并已点击保存按钮 ")]), _c("ul", [_c("li", [_vm._v("快递发函收件地址")]), _c("li", [_vm._v("邮寄回函快递公司")]), _c("li", [_vm._v("邮寄回函快递单号")])])]), _c("el-button", {
    attrs: {
      slot: "reference",
      size: "mini",
      loading: _vm.expressLoading,
      type: "text"
    },
    slot: "reference"
  }, [_vm._v("快递100物流路由 ")])], 1), _vm.isBackSFKD && (_vm.isreplyPersonnel || _vm.isCpscAdmin || _vm.isGroup || _vm.roles.includes("查询")) ? _c("el-button", {
    staticClass: "type3",
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      size: "mini",
      disabled: !_vm.baseForm.c02BackNumber,
      loading: _vm.expressLoading,
      type: "text"
    },
    on: {
      click: function click($event) {
        return _vm.getHZTLogistics(2);
      }
    }
  }, [_vm._v("顺丰物流路由 ")]) : _vm._e()], 1)])])], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "快递公司",
      prop: "c02BackCompany"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("邮寄回函快递公司")]), _c("el-tooltip", {
    staticClass: "mr-8",
    attrs: {
      slot: "label",
      effect: "dark",
      content: "输入关键字可搜索指定快递公司",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("div", {
    staticClass: "form-item-content-wrap"
  }, [_c("div", {
    staticClass: "left ellipsis"
  }, [_c("cpsc-select", {
    staticClass: "select",
    attrs: {
      disabled: _vm.cpsccAdminPermissions ? !_vm.cpsccAdminPermissions : !(_vm.stepActive === 3 && _vm.stepThreePermissions),
      filterable: "",
      data: _vm.sendCompany,
      "is-filter": true,
      clearable: "",
      "filter-name": "text",
      "default-data-items": _vm.defaultDataItems,
      "filter-code": "code",
      placeholder: "请选择邮寄回函快递公司"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var data = _ref2.data;
        return _vm._l(data, function (item) {
          return _c("el-option", {
            key: item.code,
            attrs: {
              label: item.text,
              value: item.text
            }
          });
        });
      }
    }], null, false, 876881965),
    model: {
      value: _vm.baseForm.c02BackCompany,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02BackCompany", $$v);
      },
      expression: "baseForm.c02BackCompany"
    }
  })], 1)])])], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "寄出日期",
      prop: "c02BackSendDate"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("邮寄回函寄出日期")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "对接快递100获取物流轨迹，自动提取快递寄出日期；如无法对接获取，请手工指定",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("el-date-picker", {
    staticClass: "app-form-component-select",
    attrs: {
      type: "date",
      disabled: _vm.cpsccAdminPermissions ? !_vm.cpsccAdminPermissions : !(_vm.stepActive === 3 && _vm.stepThreePermissions),
      "value-format": "yyyy-MM-dd",
      placeholder: "请选择邮寄回函寄出日期"
    },
    model: {
      value: _vm.baseForm.c02BackSendDate,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02BackSendDate", $$v);
      },
      expression: "baseForm.c02BackSendDate"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "收件日期",
      prop: "c02BackConfirmActualDate"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("邮寄回函收件日期")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "对接快递100获取物流轨迹，自动提取快递收件日期；如无法对接获取，请手工指定",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("el-date-picker", {
    staticClass: "app-form-component-select",
    attrs: {
      type: "date",
      disabled: _vm.cpsccAdminPermissions ? !_vm.cpsccAdminPermissions : !(_vm.stepActive === 3 && _vm.stepThreePermissions),
      "value-format": "yyyy-MM-dd",
      placeholder: "请选择邮寄回函收件日期"
    },
    model: {
      value: _vm.baseForm.c02BackConfirmActualDate,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02BackConfirmActualDate", $$v);
      },
      expression: "baseForm.c02BackConfirmActualDate"
    }
  })], 1)], 1)], 1), _c("el-row", {
    staticClass: "row",
    attrs: {
      align: "top",
      gutter: 30,
      type: "flex"
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "寄出地址",
      prop: "c02BackAddress"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("邮寄回函寄出地址")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "按快递面单的寄出地址录入，并执行与快递物流轨迹的寄出地域进行人工比对，如发现异常，需在回函检查说明中描述",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("el-input", {
    staticClass: "app-form-component-select",
    attrs: {
      maxlength: 100,
      disabled: _vm.cpsccAdminPermissions ? !_vm.cpsccAdminPermissions : !(_vm.stepActive === 3 && _vm.stepThreePermissions),
      placeholder: "请输入邮寄回函寄出地址"
    },
    model: {
      value: _vm.baseForm.c02BackAddress,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02BackAddress", $$v);
      },
      expression: "baseForm.c02BackAddress"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "邮寄回函寄件人",
      prop: "c02BackSendName"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("邮寄回函寄件人")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "按快递面单的寄件人姓名录入，如姓名标*，请尽量获取正确的全名，用于插件中内部人员接触函证风险核查",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("el-input", {
    staticClass: "app-form-component-select",
    attrs: {
      disabled: _vm.cpsccAdminPermissions ? !_vm.cpsccAdminPermissions : !(_vm.stepActive === 3 && _vm.stepThreePermissions),
      placeholder: "请输入邮寄回函寄件人"
    },
    model: {
      value: _vm.baseForm.c02BackSendName,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02BackSendName", $$v);
      },
      expression: "baseForm.c02BackSendName"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "邮寄回函寄件人电话",
      prop: "c02BackSendMobile"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("邮寄回函寄件人电话")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "按快递面单的寄件电话号码录入，如号码标*，请尽量获取正确的号码，用于插件中内部人员接触函证风险核查",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("el-input", {
    staticClass: "app-form-component-select",
    attrs: {
      disabled: _vm.cpsccAdminPermissions ? !_vm.cpsccAdminPermissions : !(_vm.stepActive === 3 && _vm.stepThreePermissions),
      placeholder: "请输入寄件人电话"
    },
    model: {
      value: _vm.baseForm.c02BackSendMobile,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02BackSendMobile", $$v);
      },
      expression: "baseForm.c02BackSendMobile"
    }
  })], 1)], 1)], 1), _c("el-row", {
    staticClass: "row",
    attrs: {
      align: "top",
      gutter: 30,
      type: "flex"
    }
  }, [_c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "回函快递面单附件",
      prop: "c02BackWaybill",
      "label-width": "130px"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("邮寄回函快递面单附件")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "如需分开存储回函快递面单附件文档，请在此处指定文件上传",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("div", {
    staticClass: "form-item-content-wrap"
  }, [_c("div", {
    staticClass: "left"
  }, [_vm.baseForm.c02BackWaybill ? _c("el-popover", {
    attrs: {
      placement: "top-start",
      width: "200",
      trigger: "hover"
    }
  }, [_c("div", {
    staticClass: "view-wrap"
  }, [_c("p", {
    staticClass: "view-detail",
    on: {
      click: function click($event) {
        return _vm.getFileUrl2(false, "c02BackWaybill");
      }
    }
  }, [_vm._v(_vm._s(_vm.c02BackWaybillName))]), _c("p", {
    staticClass: "view-detail download",
    on: {
      click: function click($event) {
        return _vm.getFileUrl2(true, "c02BackWaybill");
      }
    }
  }, [_vm._v("下载")])]), _c("span", {
    attrs: {
      slot: "reference"
    },
    slot: "reference"
  }, [_c("cpsc-icon", {
    attrs: {
      hover: true,
      name: "el-icon-view"
    }
  })], 1)]) : _vm._e()], 1), (_vm.cpsccAdminPermissions ? _vm.cpsccAdminPermissions : _vm.stepActive === 3 && _vm.stepThreePermissions) ? _c("div", {
    staticClass: "left text-right form-item-content-wrap"
  }, [_c("el-popover", {
    attrs: {
      placement: "top-start",
      title: "文件上传",
      width: "200",
      trigger: "hover"
    }
  }, [_c("div", {
    staticClass: "file-flex-wrap"
  }, [_c("cpsc-file-upload", {
    staticClass: "left",
    attrs: {
      clear: true,
      accept: ".pdf,.jpg,.png,.zip",
      "btn-text": "本地上传",
      "show-list": false,
      type: "text"
    },
    on: {
      change: function change(files) {
        return _vm.waybillFileChange(files, "c02BackWaybill");
      }
    }
  }), _c("el-button", {
    staticClass: "right type2",
    attrs: {
      type: "text",
      size: "mini"
    },
    on: {
      click: function click($event) {
        return _vm.showAltimeter(3, "邮寄回函快递面单附件");
      }
    }
  }, [_vm._v("高拍仪上传")])], 1), _c("el-button", {
    attrs: {
      slot: "reference",
      type: "text",
      size: "mini"
    },
    slot: "reference"
  }, [_vm._v("文件上传")])], 1), _vm.baseForm.c02BackWaybill && _vm.stepThreePermissions ? _c("el-button", {
    staticClass: "right",
    attrs: {
      size: "mini",
      type: "text"
    },
    on: {
      click: function click($event) {
        return _vm.removeBackConfirmFile("c02BackWaybill");
      }
    }
  }, [_vm._v("删除 ")]) : _vm._e()], 1) : _vm._e()])])], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "收函费用",
      prop: "c02BackFee"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("邮寄回函到付费用")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "如为到付件，需录入函证面单上的费用金额，如为寄付件，请指定金额为0",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("el-input-number", {
    staticClass: "app-form-component-select",
    attrs: {
      disabled: _vm.cpsccAdminPermissions ? !_vm.cpsccAdminPermissions : !(_vm.stepActive === 3 && _vm.stepThreePermissions),
      step: 1,
      precision: 1,
      min: 0,
      placeholder: "请输入邮寄回函到付费用"
    },
    on: {
      change: _vm.updateBackFee
    },
    model: {
      value: _vm.baseForm.c02BackFee,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02BackFee", $$v);
      },
      expression: "baseForm.c02BackFee"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "费用所属",
      prop: "c02BackBelong"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("邮寄回函费用归属")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "收函费用金额不为0，请指定费用所属为被审客户或本所部组，否则请指定不适用",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("cpsc-select", {
    staticClass: "select",
    attrs: {
      disabled: _vm.cpsccAdminPermissions ? !_vm.cpsccAdminPermissions : !(_vm.stepActive === 3 && _vm.stepThreePermissions),
      filterable: "",
      clearable: "",
      placeholder: "请选择邮寄回函费用归属"
    },
    on: {
      change: _vm.backBelongChange
    },
    model: {
      value: _vm.baseForm.c02BackBelong,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02BackBelong", $$v);
      },
      expression: "baseForm.c02BackBelong"
    }
  }, _vm._l(_vm.costTypes, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.name,
        value: item.value
      }
    });
  }), 1)], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "费用回收状态",
      prop: "c02BackFeeStatus"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("邮寄回函到付费用回收状态")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "费用所属为被审客户，请指定为待结算，否则请指定为不适用",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("cpsc-select", {
    staticClass: "select",
    attrs: {
      disabled: _vm.cpsccAdminPermissions ? !_vm.cpsccAdminPermissions : !(_vm.stepActive === 3 && _vm.stepThreePermissions),
      filterable: "",
      clearable: "",
      placeholder: "请选择邮寄回函到付费用回收状态"
    },
    model: {
      value: _vm.baseForm.c02BackFeeStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02BackFeeStatus", $$v);
      },
      expression: "baseForm.c02BackFeeStatus"
    }
  }, _vm._l(_vm.costStates, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.name,
        value: item.value
      }
    });
  }), 1)], 1)], 1)], 1), _c("el-row", {
    staticClass: "row",
    attrs: {
      align: "top",
      gutter: 30,
      type: "flex"
    }
  }, [_c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "收寄地址距离",
      prop: "c02BackAddressDistance"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("收件地址vs回函寄出地址距离")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "调用第三方地图(需配置接口参数)，自动比对快递发函收件地址与邮寄回函寄出地址的距离，如超出阈值，自动置地址核查结论为异常（可手工指定为正常）。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("div", {
    staticClass: "form-item-content-wrap"
  }, [_c("div", {
    staticClass: "left ellipsis",
    attrs: {
      title: _vm.$options.filters.km(_vm.baseForm.c02BackAddressDistance)
    }
  }, [_vm._v(_vm._s(_vm._f("km")(_vm.baseForm.c02BackAddressDistance)))]), _c("div", {
    staticClass: "right"
  }, [_c("el-button", {
    attrs: {
      disabled: _vm.cpsccAdminPermissions ? !_vm.cpsccAdminPermissions : !(_vm.stepActive === 3 && _vm.stepThreePermissions),
      size: "mini",
      type: "text"
    },
    on: {
      click: function click($event) {
        return _vm.viewMap("computed", "reply");
      }
    }
  }, [_vm._v("计算 ")]), _c("el-button", {
    attrs: {
      size: "mini",
      type: "text"
    },
    on: {
      click: function click($event) {
        return _vm.viewMap("view", "reply");
      }
    }
  }, [_vm._v("查看")])], 1)])])], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "地址核对方式",
      prop: "c02BackAddressCheck"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("收件地址vs回函寄出地址核对方式")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "如无法通过第三方自动计算地址距离，请指定为[人工]，并在地址核验过程中详细描述地址核查情况。或指定为[天地图]，在地址核验过程自动记录接口返回数据。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("cpsc-select", {
    staticClass: "select",
    attrs: {
      disabled: _vm.cpsccAdminPermissions ? !_vm.cpsccAdminPermissions : !(_vm.stepActive === 3 && _vm.stepThreePermissions),
      filterable: "",
      placeholder: "请选择收件地址vs回函寄出地址核对方式"
    },
    model: {
      value: _vm.baseForm.c02BackAddressCheck,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02BackAddressCheck", $$v);
      },
      expression: "baseForm.c02BackAddressCheck"
    }
  }, _vm._l(_vm.checkTypes, function (item) {
    return _c("el-option", {
      key: item.text,
      attrs: {
        label: item.text,
        disabled: item.disabled,
        value: item.text
      }
    });
  }), 1)], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "回函验证过程",
      prop: "c02BackCheckProcess"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("收件地址vs回函寄出地址核验过程")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "通过[人工]方式进行地址核对，请输入人工地址核验过程描述。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("div", {
    staticClass: "form-item-content-wrap"
  }, [_c("preview-html", {
    staticClass: "left",
    attrs: {
      placement: "bottom",
      content: _vm.baseForm.c02BackCheckProcess
    }
  }), _c("div", {
    staticClass: "right text-right"
  }, [_c("el-button", {
    attrs: {
      size: "mini",
      type: "primary",
      disabled: _vm.cpsccAdminPermissions ? !_vm.cpsccAdminPermissions : !(_vm.stepActive === 3 && _vm.stepThreePermissions)
    },
    on: {
      click: function click($event) {
        return _vm.changeRecord("baseForm", "c02BackCheckProcess");
      }
    }
  }, [_vm._v("编辑 ")])], 1)], 1)])], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "地址检查结论",
      prop: "c02BackAddressStatus"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("收件地址vs回函寄出地址检查结论")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "按照回函地址距离及检查情况，确认回函地址检查结论是否异常，用于提示项目组成员再次复验",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("cpsc-select", {
    staticClass: "select",
    attrs: {
      disabled: _vm.cpsccAdminPermissions ? !_vm.cpsccAdminPermissions : !(_vm.stepActive === 3 && _vm.stepThreePermissions),
      placeholder: "请选择收件地址vs回函寄出地址检查结论"
    },
    model: {
      value: _vm.baseForm.c02BackAddressStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02BackAddressStatus", $$v);
      },
      expression: "baseForm.c02BackAddressStatus"
    }
  }, [_c("el-option", {
    attrs: {
      label: "正常",
      value: "正常"
    }
  }), _c("el-option", {
    attrs: {
      label: "异常",
      value: "异常"
    }
  })], 1)], 1)], 1)], 1)] : _vm._e()], 2)]), _c("div", {
    ref: "step-4",
    staticClass: "box"
  }, [_c("div", {
    staticClass: "box-type"
  }, [_vm._v(" 项目组回函后续跟踪"), _vm.stepActive !== 4 && _vm.isGroup ? _c("span", [_vm._v("(只读)")]) : _vm._e()]), _c("div", {
    staticClass: "box-content remove-form-disabled-style"
  }, [_c("el-row", {
    staticClass: "row",
    attrs: {
      align: "top",
      gutter: 30,
      type: "flex"
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "地址异常后续跟踪说明",
      prop: "c02BackAddressFllow"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("项目组针对地址核查结论为【异常】的后续跟踪说明")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "回函地址核查结论为异常的，项目组需在此输入核查情况说明",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("el-input", {
    staticClass: "app-form-component-select",
    attrs: {
      maxlength: 3000,
      disabled: !(_vm.stepActive === 4 && _vm.isGroup),
      type: "textarea",
      "show-word-limit": "",
      rows: 5,
      placeholder: "针对回函地址核查结论为【异常】的, 需在此输入核查情况说明, 并最终确认地址状态是否正常。如地址核查结论为【正常】, 此处可不用输入情况说明。"
    },
    model: {
      value: _vm.baseForm.c02BackAddressFllow,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02BackAddressFllow", $$v);
      },
      expression: "baseForm.c02BackAddressFllow"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "函证初判/结论异常跟踪说明",
      prop: "c02BackConfirmFllow"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("项目组针对函证初判结论为【异常】及函证结论【不符】的后续跟踪说明")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "函证初判为异常，或函证结论为不符，项目组需在此输入跟踪情况说明",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("el-input", {
    staticClass: "app-form-component-select",
    attrs: {
      maxlength: 3000,
      type: "textarea",
      disabled: !(_vm.stepActive === 4 && _vm.isGroup),
      "show-word-limit": "",
      rows: 5,
      placeholder: "针对函证初判为【异常】或者函证结论为【不符】的，需在此输入检查及跟踪情况说明，并最终确认回函是否有效。如函证初判为【正常】且函证结论为【相符】，此处可不用输入跟踪说明。"
    },
    model: {
      value: _vm.baseForm.c02BackConfirmFllow,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02BackConfirmFllow", $$v);
      },
      expression: "baseForm.c02BackConfirmFllow"
    }
  })], 1)], 1)], 1), _c("el-row", {
    staticClass: "row",
    attrs: {
      align: "top",
      gutter: 30,
      type: "flex"
    }
  }, [_c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "再次确认地址状态",
      prop: "c02BackAddressReStatus"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("项目组最终确认地址状态")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "项目组需指定回函地址状态是否正常",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("cpsc-select", {
    staticClass: "select",
    attrs: {
      disabled: !(_vm.stepActive === 4 && _vm.isGroup),
      placeholder: "请确认地址状态是否正常"
    },
    model: {
      value: _vm.baseForm.c02BackAddressReStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02BackAddressReStatus", $$v);
      },
      expression: "baseForm.c02BackAddressReStatus"
    }
  }, [_c("el-option", {
    attrs: {
      label: "正常",
      value: "正常"
    }
  }), _c("el-option", {
    attrs: {
      label: "异常",
      value: "异常"
    }
  })], 1)], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "再次确认回函有效性",
      "label-width": "130px",
      prop: "c02BackConfirmReConclusion"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("项目组最终确认回函有效性")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "项目组需指定回函是否有效",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("cpsc-select", {
    staticClass: "select",
    attrs: {
      disabled: !(_vm.stepActive === 4 && _vm.isGroup),
      placeholder: "请确认回函是否有效"
    },
    model: {
      value: _vm.baseForm.c02BackConfirmReConclusion,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02BackConfirmReConclusion", $$v);
      },
      expression: "baseForm.c02BackConfirmReConclusion"
    }
  }, [_c("el-option", {
    attrs: {
      label: "有效",
      value: "有效"
    }
  }), _c("el-option", {
    attrs: {
      label: "无效",
      value: "无效"
    }
  })], 1)], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "跟踪处理人姓名",
      prop: "c02BackACTrackStaffName"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("跟踪处理人姓名")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "后续跟踪处理后自动记录项目组人员姓名",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("el-input", {
    attrs: {
      placeholder: "自动录入",
      readonly: true,
      value: "".concat(_vm.baseForm.c02BackACTrackStaffName)
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "跟踪处理日期",
      prop: "c02BackACTrackDate"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("跟踪处理日期")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "后续跟踪处理后自动记录处理日期",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("el-input", {
    attrs: {
      placeholder: "自动录入",
      readonly: true,
      value: "".concat(_vm.baseForm.c02BackACTrackDate ? _vm.baseForm.c02BackACTrackDate : "")
    }
  })], 1)], 1)], 1)], 1)]), _c("div", {
    ref: "step-5",
    staticClass: "box"
  }, [_c("div", {
    staticClass: "box-type"
  }, [_vm._v(" 原件领取"), !(_vm.stepActive === 5 && _vm.stepFivePermissions) ? _c("span", [_vm._v("(只读)")]) : _vm._e()]), _c("div", {
    staticClass: "box-content remove-form-disabled-style"
  }, [_c("el-row", {
    staticClass: "row",
    attrs: {
      align: "top",
      gutter: 30,
      type: "flex"
    }
  }, [_c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "原件状态",
      prop: "c02GetStatus"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("回函原件状态")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "[未领取]保存于函证中心；[已领取]由项目组人员领走；[不适用]非邮寄到函证中心的纸质回函。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("cpsc-select", {
    staticClass: "select",
    attrs: {
      disabled: !(_vm.stepActive === 5 && _vm.stepFivePermissions),
      placeholder: "请选择原件状态"
    },
    model: {
      value: _vm.baseForm.c02GetStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02GetStatus", $$v);
      },
      expression: "baseForm.c02GetStatus"
    }
  }, [_c("el-option", {
    attrs: {
      label: "未领取",
      value: "未领取"
    }
  }), _c("el-option", {
    attrs: {
      label: "已领取",
      value: "已领取"
    }
  }), _c("el-option", {
    attrs: {
      label: "不适用",
      value: "不适用"
    }
  })], 1)], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "领取人姓名",
      prop: "c02GetStaff"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("回函原件领取人")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "操作批量领取时，由函证中心输入领取人员姓名。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("el-input", {
    staticClass: "app-form-component-select",
    attrs: {
      disabled: !(_vm.stepActive === 5 && _vm.stepFivePermissions),
      placeholder: "请输入回函原件领取人"
    },
    model: {
      value: _vm.baseForm.c02GetStaff,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02GetStaff", $$v);
      },
      expression: "baseForm.c02GetStaff"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "领取日期",
      prop: "c02GetDate"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("回函原件领取日期")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "操作批量领取时，由函证中心输入领取日期。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("el-date-picker", {
    staticClass: "app-form-component-select",
    attrs: {
      type: "date",
      disabled: !(_vm.stepActive === 5 && _vm.stepFivePermissions),
      "value-format": "yyyy-MM-dd",
      placeholder: "请选择回函原件领取日期"
    },
    model: {
      value: _vm.baseForm.c02GetDate,
      callback: function callback($$v) {
        _vm.$set(_vm.baseForm, "c02GetDate", $$v);
      },
      expression: "baseForm.c02GetDate"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    staticClass: "form-in-line-form-item",
    attrs: {
      label: "操作人/日期",
      prop: "c02GetOperateStaffName"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_c("span", [_vm._v("函证中心移交回函原件操作人/日期")]), _c("el-tooltip", {
    attrs: {
      slot: "label",
      effect: "dark",
      content: "自动记录操作领取函证原件的函证中心人员姓名及操作日期。",
      placement: "top"
    },
    slot: "label"
  }, [_c("span", [_c("cpsc-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      name: "el-icon-info"
    }
  })], 1)])], 1), _c("el-input", {
    attrs: {
      readonly: true,
      value: "".concat(_vm.baseForm.c02GetOperateStaffName, "/").concat(_vm.$options.filters.date(_vm.baseForm.c02GetDate, "yyyy-MM-dd"))
    }
  })], 1)], 1)], 1)], 1)])])], 1), _vm.template ? _c(_vm.template, {
    tag: "component"
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };